import R from 'ramda';
import { getCoords, getEventData } from '../helper';

export const SET_START = 'BEAMLY/CCX/SET_START_DRAG_SWIPE';
export const SET_CURRENT_COORDS = 'BEAMLY/CCX/SET_CURRENT_COORDS_DRAG_SWIPE';
export const SET_DRAGGING = 'BEAMLY/CCX/SET_DRAGGING_DRAG_SWIPE';

const swipeTimeThreshold = 350;
const swipeDistanceThreshold = 10;

export const onStart = ({ id, event, startTimestamp }) => ({
  type: SET_START,
  id,
  startCoords: getCoords(event),
  startTimestamp,
});

export const setCurrentCoords = ({ id, currentCoords }) => ({
  type: SET_CURRENT_COORDS,
  id,
  currentCoords,
});

export const setDragging = ({ id }) => ({
  type: SET_DRAGGING,
  id,
});

export const onMove = ({ id, event }) => (dispatch, getState) => {
  const {
    startCoords,
    isDragging,
  } = R.pathOr({}, ['dragSwipe', id])(getState());

  const currentCoords = getCoords(event);
  const eventData = getEventData({ currentCoords, startCoords });

  dispatch(setCurrentCoords({ id, currentCoords }));

  if (!isDragging) {
    dispatch(setDragging({ id }));
    return { type: 'drag-start', eventData };
  }

  return { type: 'drag', eventData };
};

export const onEnd = ({ id }) => (dispatch, getState) => {
  const {
    startCoords,
    startTimestamp,
    currentCoords,
    isDragging,
  } = R.pathOr({}, ['dragSwipe', id])(getState());

  const now = new Date();
  const eventData = getEventData({ currentCoords, startCoords });

  const didSwipe = (
    startTimestamp &&
    now.getTime() - startTimestamp.getTime() < swipeTimeThreshold &&
    eventData.absDistance > swipeDistanceThreshold
  );

  if (didSwipe) {
    return { type: 'swipe', eventData };
  }

  if (isDragging) {
    return { type: 'drag-end', eventData };
  }

  return { type: '', eventData };
};
